import React, { useState } from 'react';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { FlatIcon } from 'components/atoms/Icons/FlatIcon';
import useStyle from './carouselTags.style';
import { ProductCategory } from 'types/product/product';

export interface CarouselTagsProps {
  tags: ProductCategory[];
}

export const CarouselTags = ({ tags }: CarouselTagsProps) => {
  const classes = useStyle();
  const tagsLength = tags.length;
  const [position, setPosition] = useState(1);
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      loop: true,
      slideChanged() {
        setPosition(instanceRef.current.track.details.rel + 1);
      }
    },
    []
  );

  return (
    <div className={classes.root}>
      <div className={classes.descTags}>
        <FlatIcon icon={'LabelTag'} size="small" color="#FFFFFF" />
        <span>
          {position} / {tagsLength}
        </span>
      </div>
      <div ref={sliderRef} className="keen-slider">
        {tags.map((tag, index) => (
          <div key={index} className="keen-slider__slide">
            {tag.name}
          </div>
        ))}
      </div>
    </div>
  );
};
